import { useState } from "react";
import type { TextareaHTMLAttributes } from "react";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  rows?: number;
  maxLength?: number;
}

export function Textarea({
  label,
  value,
  placeholder,
  helperText,
  error = false,
  disabled = false,
  rows = 4,
  maxLength,
  style,
  ...rest
}: TextareaProps) {
  const [focused, setFocused] = useState(false);
  const count = String(value ?? "").length;
  return (
    <label style={{ display: "flex", flexDirection: "column", gap: 6, fontFamily: "var(--font-sans)", ...style }}>
      {label && (
        <span
          style={{
            fontSize: "var(--font-size-label-1)",
            lineHeight: "var(--line-height-label-1)",
            fontWeight: 600,
            color: "var(--label-normal)",
          }}
        >
          {label}
        </span>
      )}
      <div
        style={{
          padding: 14,
          borderRadius: "var(--radius-md)",
          background: disabled ? "var(--background-normal-alternative)" : "var(--background-normal-normal)",
          boxShadow: `inset 0 0 0 ${focused && !error ? 1.5 : 1}px ${
            error ? "var(--status-negative)" : focused ? "var(--primary-normal)" : "var(--line-normal-normal)"
          }`,
          transition: "box-shadow var(--duration-fast) var(--ease-standard)",
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <textarea
          value={value}
          placeholder={placeholder}
          rows={rows}
          maxLength={maxLength}
          disabled={disabled}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={{
            width: "100%",
            border: "none",
            outline: "none",
            resize: "vertical",
            background: "transparent",
            fontFamily: "var(--font-sans)",
            fontSize: "var(--font-size-body-2)",
            lineHeight: "var(--line-height-body-2-reading)",
            color: "var(--label-normal)",
            boxSizing: "border-box",
          }}
          {...rest}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span
          style={{
            fontSize: "var(--font-size-label-2)",
            color: error ? "var(--status-negative)" : "var(--label-alternative)",
          }}
        >
          {helperText || ""}
        </span>
        {maxLength && (
          <span style={{ fontSize: "var(--font-size-label-2)", color: "var(--label-assistive)" }}>
            {count}/{maxLength}
          </span>
        )}
      </div>
    </label>
  );
}

export default Textarea;
